import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import img2 from "../assets/2.png";
import img3 from "../assets/3.png";
import img4 from "../assets/4.png";
// import PhotoGallery from "../pages/PhotoGallery";
import "../styles/Home.css";
// import Contact from "../pages/Contact";
import Certifications from "../pages/Certifications";
// In your main App.js or component
import Slider from "react-slick";
import { useNavigate } from 'react-router-dom';
// Add more as needed

const slides = [
  {
    id: 1,
    image: img2,
    title: "Building Beyond Expectations",
    subtitle:
      "Excellence in commercial construction with integrity and precision.",
  },
  {
    id: 2,
    image: img3,
    title: "Innovative Construction Solutions",
    subtitle: "Where technology meets craftsmanship.",
  },
  {
    id: 3,
    image: img4,
    title: "Your Vision, Our Blueprint",
    subtitle: "Delivering exceptional results every time.",
  },
];

const variants = {
  enter: (direction) => ({
    x: direction > 0 ? 300 : -300,
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (direction) => ({
    x: direction < 0 ? 300 : -300,
    opacity: 0,
  }),
};

const Home = () => {
  const [[page, direction], setPage] = useState([0, 0]);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  // const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const paginate = (newDirection) => {
    setPage(([prev]) => [
      (prev + newDirection + slides.length) % slides.length,
      newDirection,
    ]);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      paginate(1);
    }, 5000);
    return () => clearInterval(interval);
  }, [page]);

  const currentSlide = slides[page];

  return (
    <>
      <motion.div
        className="page"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="carousel-container">
          <AnimatePresence custom={direction}>
            <motion.div
              key={currentSlide.id}
              custom={direction}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ duration: 0.6, ease: "easeInOut" }}
              className="slide"
              style={{
                backgroundImage: `url(${currentSlide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                // height:1500,
              }}
            >
              <div className="slide-overlay" />
              <motion.div
                className="slide-content"
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.3, duration: 0.8 }}
              >
                <h1 className="slide-title">{currentSlide.title}</h1>
                <p className="slide-subtitle">{currentSlide.subtitle}</p>
                <button className="cta-button" onClick={() => navigate('/contact')}
    >
      Become A Client</button>
              </motion.div>
            </motion.div>
          </AnimatePresence>

          <div className="carousel-dots">
            {slides.map((_, i) => (
              <div
                key={i}
                className={`carousel-dot ${i === page ? "active" : ""}`}
              />
            ))}
          </div>
        </div>
      </motion.div>
      <div className="about-section">
        <h2 className="about-title">TMC Contractors</h2>
        <h3 className="about-subtitle">Building Trust. Delivering Quality.</h3>
        <p className="about-text">
          At TMC Contractors, we specialize in General Contracting and Project
          Management for Public, Educational, Federal Government Projects, State
          Government Projects, and Commercial Sectors across Indiana. With over
          30 years of experience, we bring unmatched Reliability, Craftsmanship,
          and Accountability to every project.
        </p>
        <p className="about-text">
          Founded by Kevin Thomas, and backed by a hands-on leadership team, we
          combine field expertise with real-time project tracking and
          self-perform key trades like plumbing and carpentry. From school
          renovations to municipal upgrades, we deliver results—on time and
          within budget.
        </p>
        <p className="about-highlight">
          Certified Small Business | OSHA Compliant | MBE-Minority business
          enterprise | WBE-Women business enterprise
        </p>
        <p className="about-cta">Let’s build something that lasts.</p>
      </div>

      <Certifications />
      <div className="clients-section">
        <h2 className="clients-title">Our Customer</h2>
        <p className="clients-subtitle">
          Trusted by industry leaders across Indiana
        </p>

        <Slider
          className="clients-slider"
          slick
          // dots={false}
          infinite={true}
          speed={600}
          slidesToShow={6}
          slidesToScroll={1}
          autoplay={true}
          arrows={false}
          autoplaySpeed={1500}
          responsive={[
            {
              breakpoint: 1024,
              settings: { slidesToShow: 3 },
            },
            {
              breakpoint: 768,
              settings: { slidesToShow: 2 },
            },
            {
              breakpoint: 480,
              settings: { slidesToShow: 1 },
            },
          ]}
        >
          <div className="client-logo">
            <img src={require("../assets/client/C1.png")} alt="Client 1" />
          </div>
          <div className="client-logo">
            <img src={require("../assets/client/C2.png")} alt="Client 2" />
          </div>
          <div className="client-logo">
            <img src={require("../assets/client/C3.png")} alt="Client 3" />
          </div>
          <div className="client-logo">
            <img src={require("../assets/client/C4.png")} alt="Client 4" />
          </div>
          <div className="client-logo">
            <img src={require("../assets/client/C5.png")} alt="Client 4" />
          </div>
          <div className="client-logo">
            <img src={require("../assets/client/C6.png")} alt="Client 4" />
          </div>
          <div className="client-logo">
            <img src={require("../assets/client/C7.png")} alt="Client 4" />
          </div>
          <div className="client-logo">
            <img src={require("../assets/client/C8.png")} alt="Client 4" />
          </div>
          {/* Add more as needed */}
        </Slider>
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.8 }}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%", // optional, ensures vertical centering if needed
            flexDirection: "column", // stack items vertically
            textAlign: "center", // centers text if there's any
          }}
        >
          <button className="cta-button" onClick={() => navigate('/contact')}
    >
      Become A Client</button>
        </motion.div>
      </div>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Become A Client</h2>
            <form>
              <input type="text" placeholder="Your Name" required />
              <input type="email" placeholder="Your Email" required />
              <textarea placeholder="Message" required />
              <button type="submit">Submit</button>
            </form>
            <button className="close-button" onClick={handleClose}>X</button>
          </div>
        </div>
      )}

      {/* <PhotoGallery />
      <Contact /> */}
    </>
  );
};

export default Home;
